var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPerformance = function SvgPerformance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75c-4.94 0-9 4.196-9 9.442 0 2.916 1.258 5.515 3.227 7.244a.75.75 0 1 1-.99 1.128C2.948 19.553 1.5 16.544 1.5 13.192 1.5 7.181 6.17 2.25 12 2.25s10.5 4.93 10.5 10.942c0 3.353-1.448 6.361-3.737 8.372a.75.75 0 1 1-.99-1.128C19.742 18.707 21 16.108 21 13.192c0-5.246-4.06-9.442-9-9.442Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.998 10.502-3.45 2.104a.98.98 0 1 0 1.347 1.345l2.103-3.45Zm.54-2.087c1.008-.614 2.161.54 1.547 1.547l-2.91 4.77a2.48 2.48 0 0 1-1.558 1.125c-1.786.413-3.387-1.188-2.974-2.974.15-.65.556-1.21 1.125-1.558l4.77-2.91Z"
  })));
};

export default SvgPerformance;